export type LocaleType = 'en' | 'ru' | 'de' | 'bg' | 'ar' | 'nl';

export type LanguagesType = {
  label: string;
  key: string;
  locale: LocaleType;
  allowEdit: boolean;
};

export const LANGUAGES: LanguagesType[] = [
  {
    label: 'English',
    key: 'english',
    locale: 'en',
    allowEdit: true
  },
  {
    label: 'Russian',
    key: 'russian',
    locale: 'ru',
    allowEdit: true
  },
  {
    label: 'German',
    key: 'german',
    locale: 'de',
    allowEdit: true
  }
  // {
  //   label: 'Arabic',
  //   key: 'arabic',
  //   locale: 'ar',
  //   allowEdit: true
  // },
  // {
  //   label: 'Bulgarian',
  //   key: 'bulgarian',
  //   locale: 'bg',
  //   allowEdit: true
  // }
  // {
  //   label: 'Dutch',
  //   key: 'dutch',
  //   locale: 'nl',
  //   allowEdit: true
  // }
];

const FULLY_SUPPORTED_LOCALES = ['en', 'ru', 'de'];

export const FULLY_SUPPORTED_LANGUAGES = LANGUAGES.filter(({ locale }) =>
  FULLY_SUPPORTED_LOCALES.includes(locale)
);
